import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

const audioPlayer = {
    players: [],
    element: document.querySelectorAll('.js-audio-player'),
    init() {
        this.element.forEach(el => {
            const player = new Plyr(el);
            this.players.push(player);
        });
    },
};

export default audioPlayer;
